import { DateTimePicker, TimePicker } from '@progress/kendo-react-dateinputs'
import { FieldRenderProps } from '@progress/kendo-react-form'
import React, { FunctionComponent, useEffect, useMemo, useState } from 'react'
import { Label } from "@progress/kendo-react-labels";
import { UserApi } from '../../redux/api/UserApi';
import { Setting } from '../../types/Setting/Setting';
import { SystemApi } from '../../redux/api/SystemApi';
import { getLocaleDateTimeFormat } from '../../utils/utils';

const ActionDate: FunctionComponent<FieldRenderProps> = props => {
    const {
        label,
        id,
        valid,
        disabled,
        actionDate,
        optional,
        onChange
    } = props;
    const { data: startEnd } = SystemApi.useGetStartEndQuery()
    const { data: setting } = UserApi.useGetSettingQuery(Setting.Timepicket_Interval)
    const timeInterval = setting?.Int_Value
    const minTime = setting?.Bool_Value && startEnd?.Item1 && new Date(startEnd?.Item1)
    const maxTime = setting?.Bool_Value && startEnd?.Item2 && new Date(startEnd?.Item2)
    const [date, setDate] = useState(new Date())
    useEffect(() => {
        setDate(new Date(actionDate))
    }
        , [actionDate])
    const selectedDate = actionDate ? new Date(actionDate) : new Date();

    if (!setting) return null

    return (
        <>
            <Label
                editorId={id}
                editorValid={valid}
                editorDisabled={disabled}
                optional={optional}
            >
                {label}
            </Label>
            {/* Don't validate start and end dates - v25.6, added valid=true */}
            <DateTimePicker format={getLocaleDateTimeFormat()} onChange={onChange} steps={{ minute: timeInterval }} value={selectedDate} minTime={minTime} maxTime={maxTime} valid={true} />
            {/* {JSON.stringify(actionDate)} - type: {typeof actionDate} */}
        </>
    )
}

export default ActionDate;